import React, { useState } from "react";

import { useTranslation } from "react-i18next";

import sw1 from '../../img/TraderReview/t1.png'
import sw2 from '../../img/TraderReview/t2.png'
import sw3 from '../../img/TraderReview/t3.png'
import sw4 from '../../img/TraderReview/t4.png'
import sw5 from '../../img/TraderReview/t5.png'
import sw6 from '../../img/TraderReview/t6.png'

import stars from '../../img/TraderReview/stars.png'
import check from '../../img/TraderReview/check.png'

import btn from '../../img/Home/arrow.png'

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

function TraderTestimonials () {

    const { t } = useTranslation();

    const [swiper, setSwiper] = useState({});

    const data = [
        {
            text: 'tradertest.2',
            img: sw1,
            name: 'Leon B.'
        },
        {
            text: 'tradertest.3',
            img: sw2,
            name: 'Julia N.'
        },
        {
            text: 'tradertest.4',
            img: sw3,
            name: 'Chris H.'
        },
        {
            text: 'tradertest.5',
            img: sw4,
            name: 'Ahmed Z'
        },
        {
            text: 'tradertest.6',
            img: sw5,
            name: 'Sophie T.'
        },
        {
            text: 'tradertest.7',
            img: sw6,
            name: 'Tara E.'
        },
    ]
      
    return(
        <div className="relative max-w-[1280px] xl:mx-auto mx-[20px] mt-[80px] xl:mt-[160px] flex flex-col">
            <p className="bebas text-[24px] xl:text-[48px]">{t('tradertest.1')}</p>
            <div className="xl:flex items-center gap-[20px] ml-auto hidden">
                <img src={btn} className="cursor-pointer" alt="" onClick={() => swiper.slidePrev()}/>
                <img src={btn} className="rotate-180 cursor-pointer" alt="" onClick={() => swiper.slideNext()}/>
            </div>
            <div>
                <Swiper
                    className="mt-[20px]"
                    spaceBetween={20}
                    slidesPerView={1}
                    onInit={(e) => {
                        setSwiper(e);
                    }}
                    breakpoints={{
                        1: {
                            slidesPerView: 1,
                        },
                        640: {
                            slidesPerView: 2,
                        },
                        1280: {
                            slidesPerView: 3,
                        },
                    }}
                >
                    {data.map((text, index) => (
                        <SwiperSlide key={index}>
                            <div className="bg-[#FFFFFF] h-[280px] rounded-[28px] border border-[#0038FF] relative px-[30px] py-[20px]">
                                <div className="flex gap-[28px]">
                                    <img src={text.img} alt="" />
                                    <div>
                                        <div className="flex items-center gap-[15px]">
                                            <p className="bebas text-[20px] xl:text-[25px]">{text.name}</p>
                                            <img src={check} alt="" className="flex-shrink-0"/> 
                                        </div>
                                        <img src={stars} alt="" className="w-[94px] mt-[10px]"/>
                                    </div>
                                </div>
                                <p className="mt-[30px] helvetica text-[14px] xl:text-[16px]">{t(text.text)}</p>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <div className="flex items-center gap-[20px] ml-auto xl:hidden mt-[20px]">
                <img src={btn} className="cursor-pointer" alt="" onClick={() => swiper.slidePrev()}/>
                <img src={btn} className="rotate-180 cursor-pointer" alt="" onClick={() => swiper.slideNext()}/>
            </div>
        </div>
    );
}

export default TraderTestimonials;